import React, { useEffect, useState } from 'react';

import messages from './tenantRoleMessages';

import { canCreateRegistrationForUser } from '@/shared/components/registration/registrationHelpers';
import DataCacheService from '@/shared/services/DataCacheService';
import { Dropdown, MenuItem, SplitButton } from 'react-bootstrap';
import { FaCouch, FaPlus, FaSun } from 'react-icons/fa';
import DropdownMenu from 'react-bootstrap/lib/DropdownMenu';
import { FormattedMessage } from 'react-intl';
import EnumCacheService from '@/shared/services/EnumCacheService';
import FormattedListValue from '@/shared/components/FormattedListValue';
import api from '@/shared/api';
import config from '@/config';

const AddTenantRoleDropdownButton = ({ intl, onOpenEditModal }) => {
  const [roles, setRoles] = useState([]);

  useEffect(() => {
    let mounted = true;
    EnumCacheService.getTranslated('role', intl, true).then(data => {
      if (!mounted) return;
      setRoles(data);
    });

    return () => {
      mounted = false;
    };
  }, []);

  const onSelectRole = role => {
    if (role.permissions) {
      return onOpenEditModal({ name: role.label, permissions: role.permissions });
    }
    return api.base
      .get(`${config.appUrls.api}/api/TenantRole/Permissions/${role.id}`)
      .then(({ data }) => {
        setRoles(oldRoles =>
          oldRoles.map(x => (x.id === role.id ? { ...x, permissions: data ?? {} } : x)),
        );

        return onOpenEditModal({ name: role.label, permissions: data ?? {} });
      });
  };

  return (
    <SplitButton
      onClick={() => onOpenEditModal({})}
      id="AddRegistrationButton"
      bsStyle="inverse"
      pullRight
      toggleLabel={intl.formatMessage(messages.Add)}
      title={
        <span>
          <FaPlus className="react-icon" />
          <FormattedMessage {...messages.Add} />
        </span>
      }
    >
      <MenuItem header>
        <FormattedMessage {...messages.CopyDefaultRole} />
      </MenuItem>
      {roles.map(role => (
        <MenuItem eventKey={role.id} key={role.id} onSelect={() => onSelectRole(role)}>
          {role.label}
        </MenuItem>
      ))}
    </SplitButton>
  );
};

export default AddTenantRoleDropdownButton;
